import React, { useState } from 'react';
import { LogoMark } from './LogoMark';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
const NAV_LINKS = [{
  label: 'Product',
  href: '#how-it-works'
}, {
  label: 'Benefits',
  href: '#benefits'
}, {
  label: 'ROI',
  href: '#roi'
}, {
  label: 'Pricing',
  href: '#pricing'
}, {
  label: 'Security',
  href: '#security'
}, {
  label: 'FAQ',
  href: '/faq'
}];
export function TopNav() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full bg-ink/80 backdrop-blur-md border-b border-white/5" data-id="element-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between" data-id="element-401">
        <a href="#" className="flex items-center gap-3 group" data-id="element-402">
          <LogoMark size={36} data-id="element-403" />
          <div className="flex items-baseline gap-1.5" data-id="element-404">
            <span className="font-semibold text-xl text-bone tracking-tight" data-id="element-405">
              Masube
            </span>
            <span className="text-xs font-medium text-mint uppercase tracking-[0.2em]" data-id="element-406">
              Settle
            </span>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8" data-id="element-407">
          {NAV_LINKS.map(link => link.href.startsWith('/') ? <Link key={link.href} to={link.href} className="text-sm font-medium text-bone-dim hover:text-bone transition-colors" data-id="element-408">
            
                {link.label}
              </Link> : <a key={link.href} href={link.href} className="text-sm font-medium text-bone-dim hover:text-bone transition-colors" data-id="element-409">
            
                {link.label}
              </a>)}
        </nav>

        <div className="flex items-center gap-3" data-id="element-410">
          {/* <Link
           to="/dashboard"
           className="hidden sm:inline-flex items-center justify-center px-5 py-2.5 rounded-full bg-ink-3 border border-white/10 text-bone font-medium text-sm hover:bg-ink-4 transition-colors">
           
           Login
           </Link> */}

          <a href="#book-demo" className="hidden sm:inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-mint text-ink font-semibold text-sm hover:bg-mint-dim transition-colors" data-id="element-411">
            
            Book a demo
            <svg className="w-4 h-4" viewBox="0 0 16 16" fill="none" data-id="element-412">
              <path d="M6 3l5 5-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-413" />
              
            </svg>
          </a>

          <button onClick={() => setOpen(!open)} className="md:hidden p-2 text-bone" aria-label="Menu" data-id="element-414">
            
            {open ? <X className="w-6 h-6" data-id="element-415" /> : <Menu className="w-6 h-6" data-id="element-416" />}
          </button>
        </div>
      </div>

      {open && <div className="md:hidden border-t border-white/5 bg-ink-2" data-id="element-417">
          <nav className="px-4 py-4 flex flex-col gap-1" data-id="element-418">
            {NAV_LINKS.map(link => link.href.startsWith('/') ? <Link key={link.href} to={link.href} onClick={() => setOpen(false)} className="px-3 py-3 rounded-lg text-bone-dim hover:bg-ink-3 hover:text-bone transition-colors" data-id="element-419">
            
                  {link.label}
                </Link> : <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="px-3 py-3 rounded-lg text-bone-dim hover:bg-ink-3 hover:text-bone transition-colors" data-id="element-420">
            
                  {link.label}
                </a>)}
            {/* <Link to="/dashboard" onClick={() => setOpen(false)} className="mt-2 inline-flex items-center justify-center px-5 py-3 rounded-full bg-ink-3 border border-white/10 text-bone font-medium">
                           Login
             </Link> */}
            <a href="#book-demo" onClick={() => setOpen(false)} className="mt-2 inline-flex items-center justify-center px-5 py-3 rounded-full bg-mint text-ink font-semibold" data-id="element-421">
            
              Book a demo
            </a>
          </nav>
        </div>}
    </header>;
}